module.exports = __webpack_public_path__ + "img/blog14.916c971b.jpeg";